<!--
收货信息

使用说明：

<AddUserAddress
 />

-->

<template>
    <div class="add-address-wrap">
        <transition name="slideup">
            <div class="add-address-float-box" v-show="ui.show" @touchmove="noScroll">
                <div class="title">请选择收货地址</div>
                <Icon class="icon-dialog-close" v-on:click.native="close()" :img="require('../../../assets/icon-address-close.png')" />
                <div class="form">
                    <XInput
                        type="text"
                        label="收货人"
                        placeholder="输入收货人名称"
                        @change="(v) => (this.info.reciever = v)"
                        :value="this.info.reciever"
                    />
                    <XInput
                        type="text"
                        label="联系方式"
                        placeholder="输入联系方式"
                        @change="(v) => (this.info.telephone = v)"
                        :value="this.info.telephone"
                    />
                    <XInput type="custom" label="所在区域">
                        <!-- <span class="placeholder" v-if="currArea">{{currArea.name}}</span>
          <span class="placeholder" v-else @click="showPopup"> {{info.area ? area : '选择所在区域'}}</span> -->
                        <span class="placeholder" @click="showPopup"> {{ info.area ? info.area : '选择所在区域' }}</span>
                    </XInput>
                    <div class="tip">
                        <XInput
                            type="text"
                            label="详细地址"
                            placeholder="需填写楼栋楼层或者房间号信息"
                            @change="(v) => (this.info.detail = v)"
                            :value="this.info.detail"
                        />
                    </div>
                    <div class="set-default">
                        <van-cell center title="设为默认地址">
                            <template #right-icon>
                                <van-switch size="20px" v-model="info.isDefault" active-color="#FF3333" border="false" />
                            </template>
                        </van-cell>
                    </div>
                </div>
                <ActionButton text="确定" @click="submit" />
            </div>
        </transition>

        <template v-if="ui.isIE">
            <Popup v-model="show1" position="bottom">
                <SimplePicker
                    ref="areaPick"
                    :columns="columns"
                    title="选择城市"
                    @cancel="onCancel"
                    @confirm="onConfirm"
                    @change="onChange"
                    value-key="code"
                />
            </Popup>
        </template>
        <template v-else>
            <Popup v-model="show1" position="bottom">
                <Picker
                    ref="areaPick"
                    :columns="columns"
                    show-toolbar
                    title="选择城市"
                    @cancel="onCancel"
                    @confirm="onConfirm"
                    @change="onChange"
                    value-key="name"
                />
            </Popup>
        </template>
    </div>
</template>

<script>
import ActionButton from '@/components/products/form/ActionButton';
import { Popup, Picker } from 'vant';
import api from '../../../api';

function AddressItem(name, code) {
    this.name = name;
    this.code = code;
}

AddressItem.prototype.toString = function() {
    return this.name;
};

export default {
    props: [],
    components: {
        ActionButton,
        Popup,
        Picker,
    },
    data() {
        return {
            currArea: null,
            show1: false,
            loading: true,
            columns: [
                {
                    values: [],
                    className: 'column1',
                },
                {
                    values: [],
                    className: 'column2',
                },
                {
                    values: [],
                    className: 'column3',
                },
                {
                    values: [],
                    className: 'column4',
                },
            ],

            info: {
                reciever: '',
                telephone: '',
                area: '',
                sArea: '',
                detail: '',
                ids: '',
                isDefault: false,
            },
            ui: {
                show: false,
                isIE: false,
            },
        };
    },
    methods: {
        loadData() {
            // 获取所有省
            api.product.getAddress(
                1,
                0,
                (data) => {
                    this.columns[0].values = [];
                    for (var n in data.provinces) {
                        var c = data.provinces[n];
                        this.columns[0].values.push(new AddressItem(n, c));
                    }
                    api.product.getAddress(
                        2,
                        this.columns[0].values[0].code,
                        (data) => {
                            this.columns[1].values = [];
                            for (var n in data.provinces) {
                                var c = data.provinces[n];
                                this.columns[1].values.push(new AddressItem(n, c));
                            }
                            api.product.getAddress(
                                3,
                                this.columns[1].values[0].code,
                                (data) => {
                                    this.columns[2].values = [];
                                    for (var n in data.provinces) {
                                        var c = data.provinces[n];
                                        this.columns[2].values.push(new AddressItem(n, c));
                                    }
                                    api.product.getAddress(
                                        4,
                                        this.columns[2].values[0].code,
                                        (data) => {
                                            this.columns[3].values = [];
                                            for (var n in data.provinces) {
                                                var c = data.provinces[n];
                                                this.columns[3].values.push(new AddressItem(n, c));
                                            }
                                        },
                                        (error) => {
                                            this.$toast(error.msg);
                                        }
                                    );
                                },
                                (error) => {
                                    this.$toast(error.msg);
                                }
                            );
                        },
                        (error) => {
                            this.$toast(error.msg);
                        }
                    );
                },
                (error) => {
                    this.$toast(error.msg);
                }
            );
        },
        okCb(res) {
            this.currArea = null;
            this.show1 = false;
            this.info.reciever = '';
            this.info.telephone = '';
            this.info.area = '';
            this.info.sArea = '';
            this.info.detail = '';
            this.info.ids = '';
            this.info.isDefault = '';
            this.$toast('添加成功');
            this.close();
            this.$emit('onAddressReload');
        },
        submit() {
            let area = this.info.sArea;
            let detail = this.info.detail;
            let reciever = this.info.reciever;
            let telephone = this.info.telephone;
            let isDefault = this.info.isDefault;
            let reg = /^(0|86|17951)?(13[0-9]|14[57]|15[0-9]|16[0-9]|17[678]|18[0-9]|19[0-9])[0-9]{8}$/;
            if (reciever == '') {
                this.$toast('请输入收货人');
                return;
            }
            if (reciever.length > 6) {
                this.$toast('收货人名字不能超过6个字');
                return;
            }
            if (!reg.test(telephone)) {
                this.$toast('请输入正确的手机号码');
                return;
            }
            if (this.ids) {
                var provinceCode = this.ids[0];
                var cityCode = this.ids[1];
                var districtCode = this.ids[2];
                var townCode = this.ids[3] ? this.ids[3] : 0;
            } else {
                this.$toast('请选择地址');
                return;
            }
            if (detail == '') {
                this.$toast('请输入详细地址');
                return;
            }
            debugger
            api.product.saveAddress(provinceCode, cityCode, districtCode, townCode, area, detail, reciever, telephone, isDefault, this.okCb);
        },
        show() {
            //重置表单
            this.currArea = null;
            this.columns = [
                {
                    values: [],
                    className: 'column1',
                },
                {
                    values: [],
                    className: 'column2',
                },
                {
                    values: [],
                    className: 'column3',
                },
                {
                    values: [],
                    className: 'column4',
                },
            ];

            this.info = {
                reciever: '',
                telephone: '',
                area: '',
                sArea: '',
                detail: '',
                ids: '',
                isDefault: false,
            };

            this.loadData();

            this.ui.show = true;
        },
        close() {
            this.ui.show = false;
        },
        showPopup() {
            this.show1 = true;
        },
        onCancel() {
            this.show1 = false;
        },
        onConfirm() {
            var address = this.$refs.areaPick.getValues();
            console.log(address);
            var ids = [];
            var area = '';
            var sarea = '';
            for (var c in address) {
                if (address[c] && typeof address[c] == 'object') {
                    area += address[c].name + '-';
                    sarea += address[c].name + '|';
                    ids.push(address[c].code);
                }
            }
            console.log(ids);
            area = area.substring(0, area.length - 1);
            this.info.area = area;
            this.info.sArea = sarea;
            this.ids = ids;
            this.show1 = false;
        },
        onChange(picker, values, index) {
            console.log('onChange: ' + index);
            if (index == 0) {
                // 选择第一列
                var provincesId = this.$refs.areaPick.getColumnValue(0).code;
                api.product.getAddress(
                    2,
                    provincesId,
                    (data) => {
                        var city = [];
                        for (var n in data.provinces) {
                            var c = data.provinces[n];
                            city.push(new AddressItem(n, c));
                        }
                        picker.setColumnValues(1, city);
                        var cityId = city[0].code;
                        api.product.getAddress(
                            3,
                            cityId,
                            (data) => {
                                var area = [];
                                for (var n in data.provinces) {
                                    var c = data.provinces[n];
                                    area.push(new AddressItem(n, c));
                                }
                                picker.setColumnValues(2, area);
                                var areaId = area[0].code;
                                api.product.getAddress(
                                    4,
                                    areaId,
                                    (data) => {
                                        var country = [];
                                        for (var n in data.provinces) {
                                            var c = data.provinces[n];
                                            country.push(new AddressItem(n, c));
                                        }
                                        picker.setColumnValues(3, country);
                                    },
                                    (error) => {
                                        this.$toast(error.msg);
                                    }
                                );
                            },
                            (error) => {
                                this.$toast(error.msg);
                            }
                        );
                    },
                    (error) => {
                        this.$toast(error.msg);
                    }
                );
            } else if (index == 1) {
                // 选择第二列
                var cityId = this.$refs.areaPick.getColumnValue(1).code;
                api.product.getAddress(
                    3,
                    cityId,
                    (data) => {
                        var area = [];
                        for (var n in data.provinces) {
                            var c = data.provinces[n];
                            area.push(new AddressItem(n, c));
                        }
                        picker.setColumnValues(2, area);
                        var areaId = this.$refs.areaPick.getColumnValue(2).code;
                        api.product.getAddress(
                            4,
                            areaId,
                            (data) => {
                                var country = [];
                                for (var n in data.provinces) {
                                    var c = data.provinces[n];
                                    country.push(new AddressItem(n, c));
                                }
                                picker.setColumnValues(3, country);
                            },
                            (error) => {
                                this.$toast(error.msg);
                            }
                        );
                    },
                    (error) => {
                        this.$toast(error.msg);
                    }
                );
            } else if (index == 2) {
                // 选择第三列
                var areaId = this.$refs.areaPick.getColumnValue(2).code;
                api.product.getAddress(
                    4,
                    areaId,
                    (data) => {
                        var country = [];
                        for (var n in data.provinces) {
                            var c = data.provinces[n];
                            country.push(new AddressItem(n, c));
                        }
                        picker.setColumnValues(3, country);
                    },
                    (error) => {
                        this.$toast(error.msg);
                    }
                );
            }
        },
        noScroll(event) {
            event.preventDefault(); //阻止默认的处理方式(阻止下拉滑动的效果)
        },
    },
    mounted() {
        this.loadData();
        var isIE = function() {
            if (window.navigator.userAgent.indexOf('MSIE') >= 1) {
                //IE < 11
                return true;
            } else {
                if (!!window.ActiveXObject || 'ActiveXObject' in window)
                    //IE11的useragent没有MSIE字样，所以只能通过ActiveXObject来识别
                    return true;
                else return false;
            }
        };
        this.ui.isIE = isIE();
    },
};
</script>

<style lang="less" scoped>
.add-address-wrap {
    position: relative;
    z-index: 30;
}

.add-address-float-box {
    position: fixed;
    z-index: 30;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #f2f2f2;
    .title {
        color: #000;
        text-align: center;
        font-size: 4.266vw;
        line-height: 3em;
    }
    .icon-dialog-close {
        width: 2.8vw;
        height: 2.8vw;
        position: fixed;
        z-index: 21;
        top: 5.2vw;
        right: 4vw;
    }
    .form {
        margin-top: 12vw;
        padding: 0 4vw;
        background: #fff;
        .placeholder {
            float: right;
            color: #999999;
            font-size: 3.733vw;
            &:after {
                content: ' >';
                color: #999999;
            }
        }
        .tip {
            font-size: 3.733vw;
            line-height: 12.66vw;
            color: #999999;
        }
    }
}

.set-default {
    height: 13.33vw;

    color: #333;
    margin-top: 2.67vw;
    .van-cell {
        font-size: 4vw;
        height: 13.33vw;
        padding: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/products/form/AddUserAddress.vue